var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.21 51.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.8,51.21c-4.85,0-8.8-3.95-8.8-8.8V8.8C0,3.95,3.95,0,8.8,0h33.61c4.85,0,8.8,3.95,8.8,8.8v33.61c0,4.85-3.95,8.8-8.8,8.8H8.8ZM8.8,4.34c-2.46,0-4.46,2-4.46,4.46v33.61c0,2.46,2,4.46,4.46,4.46h33.61c2.46,0,4.46-2,4.46-4.46V8.8c0-2.46-2-4.46-4.46-4.46H8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.6,39.89c-2.42,0-4.75-.99-6.54-2.8-1.99-1.99-3.12-4.73-3.1-7.51.02-5.24,4.06-9.66,9.4-10.27l.27-.03.23.03c5.34.62,9.38,5.03,9.4,10.27.01,2.78-1.12,5.51-3.1,7.51-1.8,1.8-4.12,2.8-6.54,2.8ZM25.58,23.66c-3,.48-5.27,3.03-5.28,5.94,0,1.61.68,3.26,1.84,4.42.69.69,1.85,1.52,3.47,1.52s2.77-.83,3.47-1.52c1.16-1.16,1.85-2.82,1.84-4.43-.01-2.91-2.28-5.46-5.28-5.94h-.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.4,33.85c-.38,0-.75-.1-1.09-.29-.5-.29-.86-.76-1.01-1.32s-.07-1.15.22-1.65c1.39-2.4,6.67-10.35,16.37-11.91,1.08-.17,2.18-.26,3.27-.26,1.96,0,3.94.28,5.91.83,1.15.32,1.83,1.52,1.5,2.68-.26.93-1.12,1.58-2.09,1.58-.2,0-.39-.03-.59-.08-1.58-.44-3.17-.67-4.74-.67-.86,0-1.73.07-2.58.2-7.81,1.25-12.15,7.81-13.3,9.79-.39.67-1.11,1.08-1.88,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.8,33.85c-.77,0-1.49-.42-1.88-1.08-1.15-1.98-5.49-8.54-13.3-9.79-.85-.14-1.72-.2-2.58-.2-1.57,0-3.16.22-4.74.67-.19.05-.39.08-.59.08-.97,0-1.83-.65-2.09-1.59-.32-1.15.35-2.35,1.5-2.68,1.96-.55,3.95-.83,5.91-.83,1.09,0,2.2.09,3.27.26,9.7,1.55,14.98,9.51,16.37,11.91.29.5.37,1.09.22,1.65s-.51,1.03-1.01,1.32c-.33.19-.71.29-1.09.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.216eaebe622dcc14896499dca472ce19.svg";
export { ForwardRef as ReactComponent };